/**
 * Zurück-Link: die Seite, aus der ein geöffneter Datensatz kommt, vor seinem Titel und in
 * derselben Größe – „Nachweise › Kampfmittel“. In der Liste ist „Nachweise“ selbst der Titel;
 * öffnet man einen Nachweis, bleibt das Wort an seiner Stelle und der Name kommt dahinter.
 * Zurück heißt also: auf das klicken, was eben noch der Titel war.
 *
 * Grau, beim Hover in Akzentfarbe und unterstrichen. Führt fest zu der Seite, nicht im
 * Browserverlauf zurück: Wer über einen Link oder vom Zeitstrahl kommt, landet sonst irgendwo.
 */
import React from "react";
import { Box } from "@mui/material";
import { colors } from "../../../styles/theme";

interface ZurueckLinkProps {
  /** Ziel des Rückwegs, z. B. „Nachweise“ */
  label: string;
  onClick: () => void;
}

const ZurueckLink: React.FC<ZurueckLinkProps> = ({ label, onClick }) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    sx={{
      border: "none",
      background: "none",
      p: 0,
      font: "inherit",
      color: colors.text.secondary,
      whiteSpace: "nowrap",
      cursor: "pointer",
      "&:hover, &:focus-visible": {
        color: colors.brand.primary,
        textDecoration: "underline",
        textUnderlineOffset: "4px",
      },
    }}
  >
    {label}
  </Box>
);

export default ZurueckLink;
